import gettext from 'i18n/gettext';
const flow = {
    name: gettext('Withdraw Funds'),
    cancel: {
        state: 'holding.dashboard.funds.remove',
    },
    complete: {
        label: gettext('View Pending Withdrawals'),
        state: 'holding.dashboard.funds.remove',
    },
    steps: [
        {
            key: 'destination',
            state: 'holding.dashboard.funds.remove.bank-wire.destination',
            heading: gettext('Withdraw Funds'),
            label: gettext('Select Destination'),
        },
        {
            key: 'amount',
            state: 'holding.dashboard.funds.remove.bank-wire.amount',
            heading: gettext('Enter Amount'),
            label: gettext('Enter Amount'),
        },
        {
            key: 'review',
            state: 'holding.dashboard.funds.remove.bank-wire.review',
            cancel: true,
            heading: gettext('Review Withdrawal'),
            label: gettext('Review Withdrawal'),
            controls: {
                next: gettext('Confirm'),
            },
        },
        {
            key: 'complete',
            state: 'holding.dashboard.funds.remove.bank-wire.complete',
            complete: true,
            label: gettext('Complete'),
        },
    ],
};
export default flow;



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/funds/states/funds/remove/bank-wire/bank-wire-flow.ts